import React, { use, useEffect, useState } from 'react';
// import './patientList.css'
import {
    Button,
    ButtonGroup,
    Card,
    Container,
    Form,
    Image,
    Modal,
    Stack,
    Table,
} from 'react-bootstrap';
import edit from '../../Assets/Img/edit.png';
import view from '../../Assets/Img/eye.png';
import NoDraft from '../../Assets/Img/noDrafts.png';
import { useSelector } from 'react-redux';

import { useNavigate } from 'react-router';
import LoadingComponent from '../LoadingComponent';
import { Eye, Pencil, Plus, Trash2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useOpticianListMutation } from './opticianApi';
import { frenchFormatDate } from '../../helper';
import AddOptician from './addOptician';
import DeleteUser from '../Profile/deleteUser';
import { usePosListMutation } from '../Pos/posApi';
import { setSecureItem,getSecureItem,removeSecureItem } from "../../utils/secureStorage";
const OpticianList = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const user = getSecureItem('UserData');
    const [loading, setLoading] = useState(true);
    const [edit, setEdit] = useState({});
    const config = { email: '', mobile: '', search: '' };

     const [opticianConfig, setOpticianConfig] = useState(() => 
        {
            const saved = getSecureItem("opticianListConfigCopy") || config;
            return saved ? saved : config;
        });


    // const [opticianConfig, setOpticianConfig] = useState(config);
    
    const [opticianList] = useOpticianListMutation();
    const [opticianData, setOpticianData] = useState([]);
    const [posList] = usePosListMutation();

    useEffect(() => {
        console.log('opticianData === ', opticianData);
    }, [opticianData]);

    useEffect(() => {
        if (loading) {
            (async () => {
                let posListing = await posList({ email: '', mobile: '' });
                let { data } = await opticianList(opticianConfig);
                console.log(data, 'datadata');
                setOpticianData(data);
                setLoading(false);
            })();
        }
    }, [loading]);

    const handleFilterChange = (count = 1) => {
        // setPageCount(count);
        setSecureItem("opticianListConfigCopy",opticianConfig);
        setOpticianConfig({ ...opticianConfig, pageNumber: count });
        setLoading(true);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        console.log(e.target.value, 'e.target.value');

        if (name === 'search') {
            setOpticianConfig((prevValues) => {
                return {
                    ...prevValues,
                    email: value,
                    mobile: value,
                    search: value,
                };
            });
        } else {
            setOpticianConfig((prevValues) => {
                return {
                    ...prevValues,
                    [name]: value,
                };
            });
        }
    };

    useEffect(() => {
        console.log('opticianConfig === ', opticianConfig);
    }, [opticianConfig]);

    if (loading) {
        return <LoadingComponent />;
    }

    return (
        <>
            <Container fluid className="list_wrapper">
                <Stack direction="horizontal" gap={3} className="mb-3">
                    <div className="ms-auto">
                        {/* <Button variant='light' onClick={() => { setEditData({}); setShow(true) }}><Plus width={14} height={14} />{t("addPatient")}</Button> */}
                        <AddOptician
                            setLoading={setLoading}
                            edit={edit}
                            setEdit={setEdit}
                        />
                    </div>
                </Stack>
                <Card>
                    <Card.Header>
                        <Stack
                            direction="horizontal"
                            gap={3}
                            className="listing_filters"
                        >
                            <Stack direction="horizontal" gap={3}>
                                <Form.Control
                                    type="text"
                                    onChange={handleChange}
                                    value={opticianConfig.search}
                                    name="search"
                                    placeholder={t('search')}
                                />
                                {/* <Form.Control type='date' onChange={handleChange} name='startDate' />
                                <Form.Control type='date' onChange={handleChange} name='endDate' /> */}
                                <Button
                                    variant="secondary"
                                    onClick={() => handleFilterChange()}
                                >
                                    {t('search')}
                                </Button>
                            </Stack>
                             <div className="ms-auto">
                                                            <Button
                                                                variant="link"
                                                                className=""
                                                                onClick={() => {
                                                                    removeSecureItem("opticianListConfigCopy");
                                                                    setOpticianConfig(config);
                                                                    setLoading(true);
                                                                }}
                                                            >
                                                                {t('resetFilters')}
                                                            </Button>
                                         </div>
                            {/* <div className="ms-auto">
                                <Button variant='link' className='' onClick={() => {
                                    setPatientListConfig(config)
                                    setLoading(true)
                                }}>
                                    {t("resetFilters")}
                                </Button>
                            </div> */}
                        </Stack>
                    </Card.Header>
                    <Card.Body className="table_outer">
                        <Table>
                            <thead>
                                <tr>
                                    <th>{/* <input type="checkbox" /> */}</th>
                                    <th>{t('name')}</th>
                                    <th>{t('email')}</th>
                                    <th>{t('phone')}</th>
                                    <th>{t("Type d'opticien")}</th>
                                    <th>{t("PDV")}</th>
                                    <th>{t('createdOn')}</th>
                                    <th className="text-center">
                                        {t('actions')}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {opticianData.length > 0 ? (
                                    opticianData.map((item, index) => (
                                        <tr key={index}>
                                            <td>
                                                <img
                                                    src={
                                                        opticianData.profileImagePath ||
                                                        '/avatar-s-11.jpg'
                                                    }
                                                    alt="profile image"
                                                    style={{
                                                        height: '1.6rem',
                                                        width: '1.6rem',
                                                        borderRadius: '100%',
                                                        outline:
                                                            '1px solid #e9e9e9',
                                                        outlineOffset: '0.2rem',
                                                    }}
                                                />
                                            </td>
                                            <td>
                                                {item?.name} {item?.lastName}
                                            </td>
                                            <td>{item.email}</td>
                                            <td>{item.mobile}</td>
                                            <td>
                                                {t('optician')}{' '}
                                                {item.isExternal
                                                    ? 'externe'
                                                    : 'Sym-Optique'}
                                            </td>
                                           <td>{item.posEmail ? item.posEmail : "N/A"}</td>
                                            <td>
                                                {frenchFormatDate(
                                                    item.createdDate
                                                )}
                                            </td>
                                            <td>
                                                <Stack
                                                    direction="horizontal"
                                                    gap={1}
                                                >
                                                    <div className="m-auto">
                                                        <ButtonGroup>
                                                            <Button
                                                                variant="light"
                                                                onClick={() =>
                                                                    navigate(
                                                                        '/optician/view',
                                                                        {
                                                                            state: {
                                                                                userData:
                                                                                    item,
                                                                            },
                                                                        }
                                                                    )
                                                                }
                                                            >
                                                                <Stack
                                                                    direction="horizontal"
                                                                    gap={1}
                                                                >
                                                                    <Eye
                                                                        width={
                                                                            16
                                                                        }
                                                                    />
                                                                </Stack>
                                                            </Button>
                                                            {['ADMIN'].includes(
                                                                user?.userType
                                                            ) && (
                                                                <>
                                                                    <Button
                                                                        variant="light"
                                                                        onClick={() =>
                                                                            setEdit(
                                                                                item
                                                                            )
                                                                        }
                                                                    >
                                                                        <Stack
                                                                            direction="horizontal"
                                                                            gap={
                                                                                1
                                                                            }
                                                                            // onClick={() =>
                                                                            //     setEdit(
                                                                            //         item
                                                                            //     )
                                                                            // }
                                                                        >
                                                                            <Pencil
                                                                                width={
                                                                                    16
                                                                                }
                                                                            />
                                                                        </Stack>
                                                                    </Button>
                                                                    <DeleteUser
                                                                        email={
                                                                            item.email
                                                                        }
                                                                        setLoading={
                                                                            setLoading
                                                                        }
                                                                    />
                                                                </>
                                                            )}
                                                        </ButtonGroup>
                                                    </div>
                                                </Stack>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={6}>
                                            <Stack
                                                gap={2}
                                                className="mt-5 mb-5 mx-auto text-center"
                                            >
                                                <Image
                                                    src={NoDraft}
                                                    width={88}
                                                    className="mx-auto"
                                                />
                                                <h4>{t('noDataAvailable')}</h4>
                                                <p>
                                                    {t("youHaven'tCreatedAny")}
                                                </p>
                                            </Stack>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </Card.Body>
                    {/* <Card.Footer>
                        <Stack direction="horizontal" gap={3}>
                            <div className="ms-auto">
                                <Stack direction="horizontal" gap={2}>
                                    <span>{pageCount} of {Math.ceil(patientData?.listData?.userProfileData?.length < patientListConfig.pageSize ? patientData?.listData?.userProfileData?.length : patientData.listData.totalItems / patientListConfig.pageSize)}</span>
                                    <Button variant='secondary' className='paginationBar_rightSide_prev' disabled={pageCount > 1 ? false : true} onClick={() => {
                                        handleFilterChange(pageCount - 1)
                                    }}>{t("prev")}</Button>
                                    <Button className='paginationBar_rightSide_next' disabled={pageCount !== Math.ceil(patientData.listData.totalItems / 50) ? false : true} onClick={() => {
                                        handleFilterChange(pageCount + 1)
                                    }}>{t("next")}</Button>
                                </Stack>
                            </div>
                        </Stack>
                    </Card.Footer> */}
                </Card>
            </Container>
        </>
    );
};

export default OpticianList;
